export class DocsListRequest{
    user: string;
    s_ins: number;
    doc_type: string;
    alid: string;
    parm0: string;

    constructor(user: string, s_ins: number, doc_type: string, alid? : string, parm0?: string){
        this.user = user;
        this.s_ins = s_ins;
        this.doc_type = doc_type;
        this.alid = alid;
        this.parm0 = parm0;
    }
}